import axios from 'axios'
import {
	ElMessage,
	ElLoading
} from 'element-plus'

// 创建 axios 实例
const service = axios.create({
	baseURL: 'https://www.marinelinkco.com/server/',
	timeout: 300000,
	headers: {
		'Content-Type': 'application/json'
	}
})

// 请求拦截器
service.interceptors.request.use(
	config => {
		// 确保 url 是字符串类型
		if (config.url && typeof config.url !== 'string') {
			config.url = String(config.url)
		}

		// 添加 token
		const token = localStorage.getItem('token')
		if (token) {
			config.headers['Authorization'] = `Bearer ${token}`
		}

		// 如果是 FormData，删除默认的 Content-Type
		if (config.data instanceof FormData) {
			delete config.headers['Content-Type']
		}

		return config
	},
	error => {
		console.error('请求错误：', error)
		ElMessage.error('请求发送失败')
		return Promise.reject(error)
	}
)

// 响应拦截器
service.interceptors.response.use(
	response => {
		const res = response.data

		// 根据后端返回的状态码进行判断
		if (res.code !== undefined && res.code !== 200 && res.code !== 0 && res.code !== 20000) {
			if(res.code!==202){
			ElMessage.error(res.message || res.msg || '请求失败')

			// 特殊状态码处理
			if (res.code === 401) {
				ElMessage.error('登录已过期，请重新登录')
				setTimeout(() => {
					window.location.href = '/login'
				}, 1500)
			}
}
			return Promise.reject(new Error(res.message || res.msg || '请求失败'))
		}

		return res
	},
	error => {
		// 处理 HTTP 错误
		if (error.response) {
			const {
				status,
				data
			} = error.response
			const message = data?.message || data?.msg || error.message

			switch (status) {
				case 400:
					ElMessage.error('请求参数错误：' + message)
					break
				case 401:
					ElMessage.error('未授权，请重新登录')
					setTimeout(() => {
						window.location.href = '/login'
					}, 1500)
					break
				case 403:
					ElMessage.error('拒绝访问')
					break
				case 404:
					ElMessage.error('请求地址不存在')
					break
				case 500:
					ElMessage.error('服务器内部错误')
					break
				default:
					ElMessage.error(message || '请求失败')
			}
		} else if (error.message) {
			ElMessage.error(error.message)
		} else {
			ElMessage.error('网络错误，请检查网络连接')
		}

		return Promise.reject(error)
	}
)

export default service